import { useMemo } from 'react';

import UserIndicator from '@payaca/components/userIndicator/UserIndicator';
import MarkerWrapper from './MarkerWrapper';

import { useAccountUsers } from '@/api/queries/me/useAccountUsers';

import './UserMarker.sass';

import UntitledIcon from '@payaca/untitled-icons';

type Props = {
  onClick?: () => void;
  userIds: number[];
  lat: number; // required for positioning
  lng: number; // required for positioning
};
const UserMarker = ({ onClick, userIds }: Props) => {
  // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useMemo was passed a dependency list that is not an array literal. This means we can't statically verify whether you've passed the correct dependencies.
  const userId = useMemo(() => userIds?.[0], userIds);
  const accountUsers = useAccountUsers();

  /* oxlint-disable react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useMemo has missing dependencies: 'accountUsers', and 'userId' */
  const userIcon = useMemo(() => {
    const accountUser = accountUsers.find((x) => x.id === userId);
    if (userIds?.length === 1 && accountUser) {
      return (
        <UserIndicator
          user={{
            firstName: accountUser.firstname,
            lastName: accountUser.lastname,
            emailAddress: accountUser.email,
            userColour: accountUser.userColour,
            imgSrc: accountUser.avatarUrl,
          }}
          renderPointer={(userColour) => (
            <div
              style={{ backgroundColor: userColour }}
              className="triangle"
            ></div>
          )}
        />
      );
    } else if (userIds?.length) {
      return (
        <>
          <div className="multiple-users user-indicator">
            <UntitledIcon name="users-01.3" />
          </div>
          <div className="triangle"></div>
        </>
      );
    } else {
      return (
        <>
          <div className="unassigned-user user-indicator">
            <UntitledIcon name="user-minus-01.3" />
          </div>
          <div className="triangle"></div>
        </>
      );
    }
  }, [userIds]);
  /* oxlint-enable eslint-plugin-react-hooks(exhaustive-deps) */

  return (
    <MarkerWrapper onClick={onClick} className="user-marker">
      {userIcon}
    </MarkerWrapper>
  );
};
export default UserMarker;
